import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { fleetFeatures, fleetSpecs, images } from '../data/site';
export function Fleet() {
  return <section id="fleet" className="w-full bg-ink py-24 lg:py-32" data-id="element-191" data-mp="2inzu16dy0jcn">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-192" data-mp="2im56rlf78f5e">
        <div className="grid gap-12 lg:grid-cols-[1fr_0.9fr] lg:items-end lg:gap-20" data-id="element-193" data-mp="2dpojsujqk6tw">
          <Reveal data-id="element-194" data-mp="29ntj9s9mpxh6">
            <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice-400" data-id="element-195" data-mp="29ocxaxw5s1px">
              <span className="h-px w-8 bg-ice-400" aria-hidden="true" data-id="element-196" data-mp="24v0ej4e5up53" />
              The Fleet
            </p>
            <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-white sm:text-4xl lg:text-[3.1rem]" data-id="element-197" data-mp="1zxrvl1l6uh2s">
              Equipment Built for the Long Haul.
            </h2>
            <div className="mt-8 max-w-xl space-y-4 text-base leading-relaxed text-white/65" data-id="element-198" data-mp="1q1f3271dq99m">
              <p data-id="element-199" data-mp="1lztqynwo5z0h">
                Our fleet is selected and maintained for reliability across demanding long-haul routes and changing
                weather conditions.
              </p>
              <p data-id="element-200" data-mp="wyv26ap57idu">
                From Florida heat to severe winter corridors, our equipment and drivers are prepared to keep freight
                moving.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.05} data-id="element-201" data-mp="n5nv8ler7ubn">
            <dl className="grid grid-cols-2 gap-x-8 gap-y-7 border-t border-white/15 pt-8" data-id="element-202" data-mp="1awte79fzr2q6">
              {fleetSpecs.map(spec => <div key={spec.label} data-id="element-203" data-mp="1fvw7jwmlzkib">
                  <dt className="text-[11px] font-bold uppercase tracking-[0.16em] text-ice-400" data-id="element-204" data-mp="11wn47xji4kvr">{spec.label}</dt>
                  <dd className="mt-2 font-display text-[15px] font-bold tracking-tight text-white" data-id="element-205" data-mp="15xyl9eob7xsc">{spec.value}</dd>
                </div>)}
            </dl>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-5 lg:grid-cols-[1.5fr_1fr]" data-id="element-206" data-mp="3qo7eiyfgfpub">
          <Reveal data-id="element-207" data-mp="3qmcxhv7b0hvi">
            <div className="overflow-hidden rounded-2xl" data-id="element-208" data-mp="1x5gxqczwdmvo">
              <img src={images.yard} alt="Hold Fast Hauling 2024 Freightliner Cascadia tractors and Utility 3000R reefers staged at a distribution facility" className="h-72 w-full object-cover transition-transform duration-500 ease-premium hover:scale-[1.04] lg:h-[30rem]" data-id="element-209" data-mp="1x4ysiqv9bybm" />
            </div>
          </Reveal>
          <Reveal delay={0.05} data-id="element-210" data-mp="1ega9ybk8y530">
            <div className="overflow-hidden rounded-2xl" data-id="element-211" data-mp="1egk3ua8ewwdz">
              <img src={images.dock} alt="Hold Fast Hauling refrigerated trailer backed into a cold-chain warehouse loading dock" className="h-72 w-full object-cover transition-transform duration-500 ease-premium hover:scale-[1.04] lg:h-[30rem]" data-id="element-212" data-mp="19fwavj0mi5h4" />
            </div>
          </Reveal>
        </div>

        <div className="mt-5 grid gap-5 lg:grid-cols-[1fr_1.4fr]" data-id="element-213" data-mp="2ysq2q71utxbl">
          <Reveal data-id="element-214" data-mp="2twiu26i2q7py">
            <div className="overflow-hidden rounded-2xl" data-id="element-215" data-mp="2ttwm45r9tq77">
              <img src={images.tires} alt="Close-up of drive tires and rear frame on a Hold Fast Hauling Freightliner Cascadia" className="h-64 w-full object-cover object-center transition-transform duration-500 ease-premium hover:scale-[1.04] lg:h-80" data-id="element-216" data-mp="32bypvth0sgj1" />
            </div>
          </Reveal>
          <Reveal delay={0.05} data-id="element-217" data-mp="2je5jgh76togw">
            <div className="relative isolate h-64 overflow-hidden rounded-2xl lg:h-80" data-id="element-218" data-mp="2jexhrzs660av">
              <img src={images.winter} alt="Snow-lined interstate corridor on a Hold Fast Hauling winter run" className="absolute inset-0 h-full w-full object-cover" data-id="element-219" data-mp="2nf7ml9486ko5" />
              <div className="absolute inset-0 bg-ink/65" aria-hidden="true" data-id="element-220" data-mp="2xeq1vc96xi9v" />
              <div className="relative flex h-full flex-col justify-end p-8" data-id="element-221" data-mp="7pea6qwkmi8w">
                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-ice-400" data-id="element-222" data-mp="cnfwdkpamxol">Winter-Ready</p>
                <p className="mt-3 max-w-md font-display text-xl font-bold leading-snug tracking-tight text-white lg:text-2xl" data-id="element-223" data-mp="1lk4lt89ajg5e">
                  Built to operate in extreme winter conditions — nothing stops our load delivery.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-224" data-mp="1pl6mltiuw09h">
          {fleetFeatures.map((feature, i) => <li key={feature.title} className="bg-ink-900" data-id="element-225" data-mp="1zkxerojy236e" data-mpi={i}>
              <Reveal delay={0.04 * i} data-id="element-226" data-mp="1zil2ns0van19">
                <div className="group h-full p-7 transition-colors duration-200 ease-premium hover:bg-ink-800" data-id="element-227" data-mp="2dc28yb4jm39c">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-ice/15 text-ice-400 transition-transform duration-200 ease-premium group-hover:scale-110" data-id="element-228" data-mp="29ba0hk3hw2e4">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-229" data-mp="2ibomkloa9lio" />
                  </span>
                  <h3 className="mt-5 text-[12px] font-bold uppercase tracking-[0.12em] text-white" data-id="element-230" data-mp="31w5km0doqj28">{feature.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-white/55" data-id="element-231" data-mp="36uqlm20rh6rq">{feature.detail}</p>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}